<template>
    <div
        class="l-ss-c-filters-full-container">
        <div
            class="l-ss-c-filters-full-container-header"
            v-if="$screen.isMobile">
            <h2
                class="l-ss-c-filters-full-title"
                @click="$emit('close')">
                <i
                    class="l-ss-c-icon"
                    v-html="iconCategoryBack"></i>
                {{ $t('filters.backToSearch') }}
            </h2>
            <button
                class="l-ss-c-button l-ss-c-button-secondary"
                :style="{ visibility: hasSelected ? 'initial' : 'hidden' }"
                @click="handleResetFilters">
                {{ $t('filters.resetAllText') }}
            </button>
        </div>
        <div class="l-ss-c-filters-full-list-wrapper">
            <div
                class="l-ss-c-filters-full-list-column"
                v-if="toggleTypeFilters.length > 0">
                <filter-container
                    v-for="filter in toggleTypeFilters"
                    :key="filter.name"
                    :class="{ [`l-ss-c-filters-filter-${filter.type}`]: true }"
                    :filter="filter"
                    :has-results="hasResults"
                    :value="resolveValue(filter)"
                    @change="onFilterChange"/>
            </div>
            <div class="l-ss-c-filters-full-list">
                <filter-container
                    v-for="filter in checkFilters.filter(item => toggleTypeFilters.map(item => item.id).includes(item.id) === false)"
                    :key="filter.name"
                    :class="{ [`l-ss-c-filters-filter-${filter.type}`]: true }"
                    :filter="filter"
                    :has-results="hasResults"
                    :value="resolveValue(filter)"
                    @change="onFilterChange"/>
            </div>
        </div>
        <div class="l-ss-c-filters-full-actions">
            <div
                v-if="!$screen.isMobile"
                class="l-ss-c-filters-full-actions-left"></div>
            <div class="l-ss-c-filters-full-actions-center">
                <button
                    class="l-ss-c-filters-full-action l-ss-c-filters-full-action-submit l-ss-c-button l-ss-c-button-large"
                    @click="handleSearch">
                    {{ $t('filters.submitText') }}&nbsp;
                    <template v-if="computedTotal">({{ computedTotal }})</template>
                </button>
            </div>
            <div class="l-ss-c-filters-full-actions-right">
                <!--<button
                    class="l-ss-c-filters-full-action l-ss-c-filters-full-action-reset l-ss-c-button l-ss-c-button-secondary l-ss-c-button-large"
                    @click="$emit('close')">
                    {{ $t('filters.closeFilter') }}
                </button>-->
                <button
                    v-if="hasSelected && !$screen.isMobile"
                    class="l-ss-c-filters-full-action l-ss-c-filters-full-action-reset l-ss-c-button l-ss-c-button-secondary l-ss-c-button-large"
                    @click="handleResetFilters">
                    {{ $t('filters.resetAllText') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import FilterMixin from './FilterMixin';
    import iconCategoryBack from '../../assets/images/icons/category-back.svg';

    export default {
        mixins: [
            FilterMixin,
        ],
        computed: {
            checkFilters() {
                return this.filters.filter(item => !this.$configuration.hiddenFilters.includes(item.name));
            },
            toggleTypeFilters() {
                return this.checkFilters.filter(item => item.type === 'm-toggle');
            },
            iconCategoryBack() {
                return iconCategoryBack;
            },
        },
    };
</script>